import * as React from "react";

import primaryColour from "../constants";

function SvgFilledDriver(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M22.0804 18.8545C21.2744 14.0916 15.5589 12.5284 14.8018 12.3574C13.2141 13.6031 10.967 13.6031 9.3794 12.3574C8.62222 12.5284 3.02887 14.0672 2.22284 18.8545C1.80761 20.8574 1.92974 22.5671 2.95559 22.9091C3.56622 23.1045 4.56765 22.8602 5.64235 22.5183C5.66678 22.5183 5.66678 22.5183 5.69121 22.4938C5.69121 22.4938 5.69121 22.4938 5.71563 22.4938C6.37511 22.274 6.83918 21.6634 6.83918 20.9551V20.8818C6.83918 20.2712 6.49723 19.7338 6.00873 19.4651C6.86361 16.9249 9.2817 15.1175 12.1394 15.1175C14.9727 15.1175 17.3908 16.9493 18.2946 19.4896C17.8061 19.7827 17.4641 20.2956 17.4641 20.9062V20.9795C17.4641 21.7122 17.9526 22.3229 18.6121 22.5427C19.7112 22.8602 20.6882 23.1289 21.2744 22.9335C22.3247 22.616 22.4957 20.8574 22.0804 18.8545Z"
        fill={fill}
      />
      <path
        d="M12.1637 12.1378C15.091 12.1378 17.464 9.64455 17.464 6.56892C17.464 3.49329 15.091 1 12.1637 1C9.2365 1 6.8635 3.49329 6.8635 6.56892C6.8635 9.64455 9.2365 12.1378 12.1637 12.1378Z"
        fill={fill}
      />
      <path
        d="M13.8247 20.6621C13.9957 20.9552 14.0934 21.2728 14.0934 21.6391C14.0934 22.0788 13.9469 22.4696 13.7026 22.7871C15.046 22.7138 16.1695 22.5429 17.1221 22.323C17.1466 22.1032 17.171 21.859 17.171 21.6147C17.171 20.4179 16.7558 19.3432 16.0718 18.4639L13.8247 20.6621Z"
        fill={fill}
      />
      <path
        d="M10.4541 20.6621L8.23143 18.4883C7.5231 19.3432 7.10787 20.4423 7.10787 21.6391C7.10787 21.8834 7.1323 22.1276 7.15672 22.3474C8.1093 22.5673 9.23286 22.7138 10.5762 22.7871C10.332 22.4696 10.1854 22.0543 10.1854 21.6391C10.1854 21.2727 10.2831 20.9308 10.4541 20.6621Z"
        fill={fill}
      />
      <path
        d="M12.1393 20.6621C11.602 20.6621 11.1623 21.1018 11.1623 21.6391C11.1623 22.1765 11.602 22.6161 12.1393 22.6161C12.6767 22.6161 13.1163 22.1765 13.1163 21.6391C13.1163 21.1018 12.6767 20.6621 12.1393 20.6621Z"
        fill={fill}
      />
      <path
        d="M12.1393 16.6074C10.8936 16.6074 9.77002 17.0471 8.89072 17.8043L11.1378 19.9781C11.4309 19.8071 11.7729 19.7094 12.1393 19.7094C12.5056 19.7094 12.872 19.8071 13.1651 20.0025L15.4122 17.8287C14.5085 17.0715 13.3849 16.6074 12.1393 16.6074Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgFilledDriver;
